import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      // main: '#440A0A',
      main: '#000000',
    },
    secondary: {
      main: '#F0ECE5',
    },
    error: {
      main: '#B30021',
    },
    text: {
      primary: '#000',
      secondary: '#FFF',
    },
  },
  typography: {
    fontFamily: ['Helvetica'].join(','),
    h3: {
      fontWeight: 'bold',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      letterSpacing: 'normal',
    },
    subtitle1: {
      fontWeight: 'bold',
    },
    subtitle2: {
      fontWeight: 'bold',
    },
    body2: {
      letterSpacing: '0.2px',
    },
  },
  spacing: 10,
  components: {
    MuiTypography: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          return {
            ...(ownerState.variant === 'h3' && {
              [theme.breakpoints.up('sm')]: {
                fontSize: '1.95rem',
              },
            }),
            ...(ownerState.variant === 'h6' && {
              [theme.breakpoints.down('sm')]: {
                fontSize: '0.95rem',
              },
            }),
            ...(ownerState.variant === 'body2' && {
              color: theme.palette.text.primary,
            }),
          }
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          return {
            ...(ownerState.customBorder || {
              border: '1px solid',
              borderColor: '#FFF',
              borderRadius: '20px',
              background: '#fff',
              backdropFilter: 'blur(39.5px)',
            }),
          }
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          fontSize: '0.875rem',
          // fontFamily: ['Helvetica'].join(','),
          '&:before': {
            borderBottom: `1px solid ${theme.palette.primary.main} !important`,
          },
        }),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          fontSize: '0.875rem',
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          color: '#fff',
          // backgroundColor: '#440A0A',
          backgroundColor: '#000000',
          ':hover': {
            backgroundColor: '#000000',
            color: '#fff',
          },
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiList: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          color: theme.palette.primary.main,
        }),
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          fontWeight: '600',
          fontSize: '32px',
          '& .MuiFormLabel-asterisk': {
            color: 'red',
          },
        }),
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: ({ ownerState, theme }) => {
          return {
            color: ownerState.checked ? theme.palette.primary.main : theme.palette.text.primary,
            fontWeight: '500',
            fontSize: '24px',
            lineHeight: '32px',
          }
        },
      },
    },
  },
})

export default theme
